import React from "react"
import cn from "classnames"
import styles from "../../styles/scss/components/form/formSystem.module.scss"

// Shared label / help / error plumbing for every single-control field.
//
// Ids follow the control's id: `${id}-help` and `${id}-error`. The control
// gets `aria-describedby` pointing at whichever of the two are rendered, and
// `aria-invalid` when there is an error, via describedBy() below.

export const ErrorIcon = () => (
    <svg viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" focusable="false">
        <path d="M10 1.5 19 18H1L10 1.5Zm0 5.5a1 1 0 0 0-1 1v4a1 1 0 0 0 2 0V8a1 1 0 0 0-1-1Zm0 8.2a1.15 1.15 0 1 0 0 2.3 1.15 1.15 0 0 0 0-2.3Z" />
    </svg>
)

// The asterisk is decorative: the control's `required` / aria-required is
// what assistive tech announces, so the glyph is hidden from it.
export const RequiredMark = () => (
    <span className={styles.req} aria-hidden="true">
        *
    </span>
)

export const describedBy = (id, { help, error }) =>
    [help && `${id}-help`, error && `${id}-error`].filter(Boolean).join(" ") ||
    undefined

export const Help = ({ id, children }) =>
    children ? (
        <p className={styles.help} id={`${id}-help`}>
            {children}
        </p>
    ) : null

export const ErrorMessage = ({ id, children }) =>
    children ? (
        <p className={styles.error} id={`${id}-error`}>
            <ErrorIcon />
            <span>{children}</span>
        </p>
    ) : null

const Field = ({
    id,
    label,
    required,
    help,
    error,
    className,
    labelClassName,
    children,
}) => (
    <div className={cn(styles.field, className)}>
        <label className={cn(styles.label, labelClassName)} htmlFor={id}>
            {label}
            {required && <RequiredMark />}
        </label>
        {children}
        <Help id={id}>{help}</Help>
        <ErrorMessage id={id}>{error}</ErrorMessage>
    </div>
)

export default Field
